import React from 'react';
import '../Styles/HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">Add a $40–50K Monthly Revenue Line Through In-Home Care</h1>
          <p className="hero-subtitle">Expand into in-home care — without building tech or sacrificing revenue control.</p>
          <p className="hero-location">Now Activating Clinics Across the United States.</p>
          <p className="hero-location">Custom pricing based on your clinic's needs. No Heavy Upfront Investment.</p>
          <div className="hero-cta-buttons">
            <a
              href="https://shopify.getquickcare.com/products/founder-sprint-limited"
              className="cta-btn primary-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Started
            </a>
          </div>
          <div className="hero-links">
            {/* <a
              href="#how-it-works"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('.how-it-works-section')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              See how it works
            </a> */}
            {/* <span className="link-separator">-</span> */}
            <a
              href="https://calendly.com/rashu-getquickcare/getquickcare-demo"
              className="cta-btn secondary-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book a Demo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
